// extracted by mini-css-extract-plugin
export default {"shimmer":"AssistedEarnCard_shimmer__-EM5S"};